import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./recruiterReview.css"
import { faAngleRight, faChevronLeft, faChevronRight, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { Rating } from '@mui/material';
import { apiService } from '../../services/apiService';
import { toast } from 'react-toastify';
function RecruiterReviews() {

    const navigate = useNavigate();
    const [recruiterData, setRecruiterData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [shortQuery, setShortQuery] = useState("");

    const fetchData = useCallback(async (params = {}) => {
        setLoading(true);
        try {
            const queryString = new URLSearchParams(params).toString();
            const response = await apiService.getRequest(`/employee-reviews?${queryString}`);
            if (response && response.success === true) {
                setRecruiterData(response.data);
                setPaginateData(response.meta);
            }else{
                setRecruiterData([]);
                toast(response.message || "Something went wrong!");
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
        }
    }, []);
    
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchData({ page: newPage });  
    };

    const handleShortChange = (shortOption) => {
        setShortQuery(shortOption);
        fetchData({ rating: shortOption, search: searchQuery, page: 1 }); 
    };

    const handleSearch = () => {
        setCurrentPage(1);
        fetchData({ search: searchQuery, rating: shortQuery, page: 1});
    };

    useEffect(() => {
        fetchData();
    }, [fetchData]);
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                    <h3>Employee Reviews</h3>
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Employee Reviews</span>
                </Grid>
                <Grid size={{ xs: 12 }} container justifyContent="space-between" alignItems="center" className="mt-4">
                    <Grid size={{ md:4,sm:6,xs: 12 }} container flexDirection="column">
                        <div className='d-flex jobseekersearch my-3'>
                            <div className='col-md-9 input_jobssearch'>
                                <FontAwesomeIcon className='iconcol' icon={faMagnifyingGlass} />
                                <input type='text' placeholder='search'
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleSearch(); // Trigger search on Enter key press
                                    }
                                }}/>
                            </div>
                            <div className='col-md-3 col-4'>
                                <button onClick={handleSearch}>Search</button>
                            </div>
                        </div>
                    </Grid>
                    <Grid size={{ sm:4,xs: 12 }} container alignItems="center" className="gap-3" justifyContent="end">
                        <div className='d-flex my-3 short_byonboard'>
                            <label>Sort by: </label>
                            <select className='ms-2' value={shortQuery} onChange={(e) => handleShortChange(e.target.value)}>
                                <option value="">All</option>
                                <option value="5">5 Stars</option>
                                <option value="4">4 Stars</option>
                                <option value="3">3 Stars</option>
                                <option value="2">2 Stars</option>
                                <option value="1">1 Star</option>
                            </select>
                        </div>
                    </Grid>
                </Grid>
                <Grid size={{xs:12}} container className="mt-4">
                    {loading ? 
                        <div className='d-flex justify-content-center w-100'>
                            <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> :<>
                        {recruiterData && recruiterData.length > 0 ? (
                            recruiterData && recruiterData.map((datas, index) => ( 
                                <Grid size={{lg:3,md:4,xs:12}} key={index} container justifyContent="center" className="p-3" >
                                    <Grid size={{xs:12}} container flexDirection="column" className="recruitreview_main ratinglabel" alignItems="center">
                                        <Grid size={{xs:12}} container flexDirection="column" alignItems="center" className="cursetespoint" onClick={()=>navigate(`/employee-reviews/view/${datas.id}`)}>
                                            {datas.profile_picture && datas.profile_picture.length > 0 ?
                                                <img src={datas.profile_picture} alt=""/> :
                                                <img src={require("../../assets/defaultprofile.svg").default} alt="default"/>
                                            }
                                            <h6>{datas.name}</h6>
                                            <small>{datas.job_title}</small>
                                            <Rating className='rating_spanhiders my-2' disabled value={datas.avg_rating} precision={0.5}/>
                                        </Grid>
                                        <Link to={`/employee-reviews/view/${datas.id}?review`} className='sml_underline'>{datas.total_reviews} Reviews</Link>
                                    </Grid>
                                </Grid>
                                ))
                        ) : ( 
                            <div className="w-100 d-flex justify-content-center mt-4">
                                <p>No data to display</p>
                            </div>
                        )}
                    </>}
                    {paginatedata && paginatedata.last_page !== 1 && (
                        <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                            <button className='arrowpaginate' 
                                onClick={() => handlePageChange(currentPage - 1)} 
                                disabled={currentPage === 1}>
                                <FontAwesomeIcon icon={faChevronLeft} />
                            </button>
                            {paginatedata && (
                                <div className="pagination">
                                    {(() => {
                                    const totalPages = paginatedata.last_page > 0 ? paginatedata.last_page : 1;
                                    const pages = [];
                                    const start = Math.max(2, currentPage - 2);
                                    const end = Math.min(totalPages - 1, currentPage + 2);

                                    // Always show first page
                                    pages.push(
                                        <button
                                        key={1}
                                        onClick={() => handlePageChange(1)}
                                        className={currentPage === 1 ? 'active' : ''}
                                        >
                                        1
                                        </button>
                                    );

                                    if (start > 2) {
                                        pages.push(<span key="start-ellipsis">...</span>);
                                    }

                                    for (let i = start; i <= end; i++) {
                                        pages.push(
                                        <button
                                            key={i}
                                            onClick={() => handlePageChange(i)}
                                            className={currentPage === i ? 'active' : ''}
                                        >
                                            {i}
                                        </button>
                                        );
                                    }

                                    if (end < totalPages - 1) {
                                        pages.push(<span key="end-ellipsis">...</span>);
                                    }

                                    if (totalPages > 1) {
                                        pages.push(
                                        <button
                                            key={totalPages}
                                            onClick={() => handlePageChange(totalPages)}
                                            className={currentPage === totalPages ? 'active' : ''}
                                        >
                                            {totalPages}
                                        </button>
                                        );
                                    }

                                    return pages;
                                    })()}
                                </div>
                                )}


                            <button className='arrowpaginate'
                                onClick={() => handlePageChange(currentPage + 1)} 
                                disabled={currentPage === paginatedata.last_page}>
                                <FontAwesomeIcon icon={faChevronRight} />
                            </button>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default RecruiterReviews
